import { connect } from 'react-redux';

import WidgetReference from '../WidgetReference';

// Redux generated Container Component
const mapStateToProps = (state, ownProps) => {
	let widgetName = ownProps.match.params.widget;
	let widget = state.widgets.widgets[widgetName];

	return {
		categories: state.widgets.categories,
		widgets: state.widgets.widgets,
		widget: widget
	};
};

export default connect(mapStateToProps)(WidgetReference);



// WEBPACK FOOTER //
// ./src/components/widgets/containers/WidgetReferenceContainer.js